export default {
  setBank (state, bank) {
    state.bank = bank
  },

  setName (state, name) {
    state.name = name
  },

  setBranchName (state, branchName) {
    state.branchName = branchName
  },

  setAccountType (state, accountType) {
    state.accountType = accountType
  },

  setAccountNumber (state, accountNumber) {
    state.accountNumber = accountNumber
  }
}
